import React from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {Link, useLocation} from 'react-router-dom'
import {VmoPopup, VmoList, VmoListItem, VmoImage} from 'vmo-library'
import logo from 'assets/logo-white.svg'
import assets from 'assets/layer.svg'
import book from 'assets/Document.svg'
import chart from 'assets/Chart.svg'
import contact from 'assets/User01.svg'
import home from 'assets/Home.svg'
import inbox from 'assets/Message.svg'
import settings from 'assets/nav-settings.svg'
import task from 'assets/Group.svg'
import statuspage from 'assets/nav-status-page.svg'
import communitiy from 'assets/nav-communitiy.svg'

import {inboxCounts} from 'actions/inbox'
import {prod} from 'actions/endpoint'
import {
  ANALYTICS_PATH,
  ASSETS_PATH,
  CLIENT_PORTAL_PATH,
  KNOWLEDGEBASE_PATH,
  SETTINGS_PATH,
  STATUS_PAGE_PATH,
} from 'constants/path'
import {getPathWithPrefix} from 'utils/helper'

const SideBar = () => {
  const dispatch = useDispatch()
  const location = useLocation()

  const active = link => {
    return window.location.href.split('/')[4] === link ? 'active' : ''
  }
  const {countData: {unread = 0} = {}} = useSelector(state => state.emailInbox)

  React.useEffect(() => {
    if (location.pathname !== '/inbox') dispatch(inboxCounts())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch])

  return (
    <div className="vmo-navigation">
      <VmoList link className="nav-list">
        <VmoListItem className="logo-main">
          <VmoImage src={logo} />
        </VmoListItem>

        <VmoPopup
          size="small"
          position="right center"
          content="Home"
          trigger={
            <Link className={`${active('home')} item`} to="/home" id="home">
              <VmoImage src={home} />
            </Link>
          }
        />

        <VmoPopup
          size="small"
          position="right center"
          content="Inbox"
          trigger={
            <Link className={`${active('inbox')} item`} to="/inbox" id="Inbox">
              {unread > 0 && (
                <span className={unread > 3 ? 'unreadCount active' : 'unreadCount'}>
                  {unread > 99 ? '99+' : unread}
                </span>
              )}
              <VmoImage src={inbox} />
            </Link>
          }
        />

        <VmoPopup
          size="small"
          position="right center"
          content="Knowledge Base"
          trigger={
            <Link
              className={`${active(KNOWLEDGEBASE_PATH.PREFIX)} item`}
              to={`/${KNOWLEDGEBASE_PATH.PREFIX}`}
              id="knwBase"
            >
              <VmoImage src={book} />
            </Link>
          }
        />

        <VmoPopup
          size="small"
          position="right center"
          content="Tasks"
          trigger={
            <Link className={`${active('tasks')} item`} to="/tasks" id="tasks">
              <VmoImage src={task} />
            </Link>
          }
        />

        <VmoPopup
          size="small"
          position="right center"
          content="Assets"
          trigger={
            <Link className={`${active(ASSETS_PATH.PREFIX)} item`} to={`/${ASSETS_PATH.PREFIX}`} id="Assets">
              <VmoImage src={assets} />
            </Link>
          }
        />

        {!(prod === 'true') && (
          <VmoPopup
            size="small"
            position="right center"
            content="Client Portal"
            trigger={
              <Link
                className={`${active(CLIENT_PORTAL_PATH.PREFIX)} item`}
                to={`/${CLIENT_PORTAL_PATH.PREFIX}`}
                id="portal"
              >
                <VmoImage src={communitiy} />
              </Link>
            }
          />
        )}

        <VmoPopup
          size="small"
          position="right center"
          content="Status Page"
          trigger={
            <Link
              className={`${active(STATUS_PAGE_PATH.PREFIX)} item`}
              to={`/${STATUS_PAGE_PATH.PREFIX}`}
              id="statuspage"
            >
              <VmoImage src={statuspage} />
            </Link>
          }
        />

        <VmoPopup
          size="small"
          position="right center"
          content="Customers"
          trigger={
            <Link className={`${active('customers') || active('customer')} item`} to="/customers" id="Contacts">
              <VmoImage src={contact} />
            </Link>
          }
        />

        <VmoPopup
          size="small"
          position="right center"
          content="Analytics"
          trigger={
            <Link
              className={`${active('analytics')} item`}
              to={getPathWithPrefix(ANALYTICS_PATH.PREFIX, ANALYTICS_PATH.OVERVIEW)}
              id="Analytics"
            >
              <VmoImage src={chart} />
            </Link>
          }
        />

        <VmoPopup
          size="small"
          position="right center"
          content="Settings"
          trigger={
            <Link
              className={`${active(SETTINGS_PATH.PREFIX)} item`}
              to={getPathWithPrefix(SETTINGS_PATH.PREFIX, SETTINGS_PATH.MY_PROFILE)}
              id="Settings"
            >
              <VmoImage src={settings} />
            </Link>
          }
        />
      </VmoList>
    </div>
  )
}

export default SideBar
